var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"100%"}},[_c(_vm.layoutComponent,{key:_vm.whetherToRerender,tag:"component"},[_c('router-view')],1),_c('notifications',{attrs:{"position":"top center","duration":_vm.notifications.duration,"ignoreDuplicates":_vm.notifications.ignoreDuplicates,"classes":"vue-notification"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }